require('../lib/mixpanel');

module.exports = {

    trackEvent(eventName, data) {
        mixpanel.track(eventName, data);
    }

};


//////////////////
// WEBPACK FOOTER
// ./src/js/services/TrackingService.js
// module id = 19
// module chunks = 0